module.exports = __webpack_public_path__ + "media/images/ticket/ticket_confirm_banner-25d1b65c61c8bac33d67458a56105db2.png";